exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control-label[data-v-e5bb58e4] {\n    font-weight: bold;\n}\n", ""]);

// exports
